module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"copy":"Replicar","copyToAll":"Replicar para todos"},"en-US":{"copy":"Replicate","copyToAll":"Replicate to all"}}')
  delete Component.options._Ctor
}
